import { lazy, Suspense, useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useServices } from '@/model';
import { useNavigation, type SheetHandle } from '@/app/contract';
import { Spinner } from '@/ui';
import { callRuntime } from '../call-runtime';
import '../calls.css';

const Screen=lazy(()=>import('./CallScreen').then(module=>({default:module.CallScreen})));
export function CallsHost() {
  const services=useServices(), navigation=useNavigation(), client=useQueryClient();
  const current=useRef(navigation);current.current=navigation;
  const runtime=callRuntime(services);
  useEffect(()=>{
    let handle:SheetHandle|undefined, shown:unknown;
    const release=runtime.attach({
      engine(engine){
        if(engine===shown)return;
        handle?.dismiss();handle=undefined;shown=engine;
        if(engine){
          const nav=current.current;
          handle=nav.present(<Suspense fallback={<div className="calls-loading"><Spinner label="Hylo"/></div>}><Screen engine={engine} onClose={()=>runtime.dismiss(engine)} onRetry={()=>{void runtime.start(engine.conversationId,engine.kind==='video'?'video':'voice');}}/></Suspense>,{size:nav.layout==='phone'||engine.kind==='video'?'large':'small',dismissible:false});
        }
      },
    },client);
    return()=>{release();handle?.dismiss();};
  },[runtime,client]);
  return null;
}
